import React from 'react';
import { Level } from 'rbx';
import { PageHeader } from '../../../components/elements';

const Header = ({ setFee, setIsActiveModal }) => (
  <PageHeader title="Onboarding Setup Fees">
    <Level.Item align="right">
      <Level.Item>
        <button
          type="submit"
          className="button is-primary"
          onClick={() => {
            setFee(null);
            setIsActiveModal(true);
          }}
          disabled
        >
          <span>Add</span>
        </button>
      </Level.Item>
    </Level.Item>
  </PageHeader>
);

export default Header;
